import { helper } from '@ember/component/helper';
import { htmlSafe, type SafeString } from '@ember/template';

interface StyleEntrySignature {
  Args: {
    Positional: [attribute: string, value: string];
  };
  Return: SafeString;
}

export default helper<StyleEntrySignature>(function styleEntry(positional) {
  const [attribute, value] = positional;

  return htmlSafe(`${attribute}: ${value};`);
});
